import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http';
import { MeterProvider } from '@opentelemetry/sdk-metrics';

import { getResources, getTraceparentMetaContext } from '../resources';
import { CacheMetricReader } from './CacheMetricReader';

export class Module {
  constructor(aggregator, config, otelConfig) {
    this.aggregator = aggregator;
    this.config = config;
    this.otelConfig = otelConfig;
    this.meterProvider = {};
    this.attachMeterProvider('default', {
      url: this.config.url,
      headers: this.config.headers,
      compression: this.config.compression,
      temporalityPreference: 2,
      // AggregationTemporalityPreference.LOWMEMORY
    });
  }

  createMetricReader(options) {
    return new CacheMetricReader(
      {
        exporter: new OTLPMetricExporter(options),
        exportIntervalMillis: 100,
      },
      this.aggregator,
    );
  }

  attachMeterProvider(name, readerOptions) {
    if (this.meterProvider[name]) {
      return;
    }

    this.meterProvider[name] = new MeterProvider({
      resource: getResources(
        { ...this.config.resources, ...this.otelConfig.resources },
        this.aggregator.getSharedContext(),
        this.otelConfig.trace_parent_header,
      ),
      readers: [this.createMetricReader(readerOptions)],
    });
  }

  recordHistogram(
    name,
    value = 1,
    unit = null,
    tags = {},
    meterProviderName = 'default',
  ) {
    const meterProvider = this.getMeterProvider(meterProviderName);
    const context = getTraceparentMetaContext(true);
    const meter = meterProvider.getMeter(
      '__webMonitoringName__',
      '__webMonitoringVersion__',
    );

    meter.createHistogram(name, { unit }).record(value, tags, context);
  }

  recordCount(
    name,
    value = 1,
    unit = null,
    tags = {},
    meterProviderName = 'default',
  ) {
    const meterProvider = this.getMeterProvider(meterProviderName);
    const context = getTraceparentMetaContext(true);
    const meter = meterProvider.getMeter(
      '__webMonitoringName__',
      '__webMonitoringVersion__',
    );

    meter.createUpDownCounter(name, { unit }).add(value, tags, context);
  }

  /*
  recordGauge(name, unit = null, meterProviderName = 'default') {
    const meterProvider = this.getMeterProvider(meterProviderName);
    const meter = this.meterProvider.getMeter(
      '__webMonitoringName__',
      '__webMonitoringVersion__',
    );
    meter.createObservableGauge(name, { unit }).addCallback(callback);
  }
  */

  getMeterProvider(name = 'default') {
    return this.meterProvider[name ?? 'default'];
  }
}
